// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .sign-container[data-v-5fd3d0c4] {\n  padding: 0 200px;\n}\n.message-info[data-v-5fd3d0c4] {\n  color: white;\n  font-weight: normal;\n}\n[dir] .message-info[data-v-5fd3d0c4] {\n  background: #ea7037;\n  border-radius: 10px 10px 10px 10px;\n  padding: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
